@if (status) {
    <div class="cellWrapper">
        @if (messages!.length) {
            <button
                appTooltip
                class="button primary transparent link"
                [componentData]="messages"
                [class.underline]="messages!.length"
                (click)="openMessages(messages!.length)"
            >
                {{ status | translate }}
            </button>
        } @else {
            <div>{{ status | translate }}</div>
        }
    </div>
}
